
var config = {
    'lmsType': null,
    'baseUrl': null,
    'clientId': null,
    'courseId': null,
    'lti13Id': null
};

export function set(_config) {
    config = _config;
}

export function lmsType() {
    return config.lmsType;
}

export function baseUrl() {
    return config.baseUrl;
}

export function clientId() {
    return config.clientId;
}

export function courseId() {
    return config.courseId;
}

// If the client's institution report is configured with LTI 1.3, this is the
// LTI 1.3 OAuth client ID
export function lti13Id() {
    return config.lti13Id;
}
